import React, { useEffect } from 'react';
import SalesOrderForm from '../../Components/Form/SalesOrderForm/SalesOrderForm';
import FormLayout from '../../Components/Layout/FormLayout';
import { SalesOrderIcon } from '../../Assets/Navigation/NavigationIcons';
import { useTranslation } from 'react-i18next';

const CloneSalesOrder = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t('report.salesOrder.clone_sales_order');
  }, []);

  return (
    <FormLayout
      title={t('report.salesOrder.clone_sales_order')}
      Icon={SalesOrderIcon}
      closeUrl="/salesorders"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <SalesOrderForm
        id={props.match.params.id}
        type="clone"
        title="Clone"
        handleToast={props.handleToast}
      />
    </FormLayout>
  );
};

export default CloneSalesOrder;
